import * as actions from './redux/actions';

import React, { Component } from 'react';

import CommonService from '../../services/commonService';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../themes/functions/getIcons/getIcons';

export class PaymentRightSideBar extends Component {
	static propTypes = {
		pbServiceList: PropTypes.object,
		home: PropTypes.object,
		pbPaymentDetails: PropTypes.object.isRequired,
		actions: PropTypes.object.isRequired,
		basicFare: PropTypes.func,
		calculateNetFare: PropTypes.func,
		calculateNetFareUSD: PropTypes.func,
		promoCode: PropTypes.string,
		promoCouponAmount: PropTypes.number,
		t: PropTypes.func,
		showUsd: PropTypes.bool,
		onPromoRemove: PropTypes.func,
		corporateDiscountState: PropTypes.object,
		instantDiscount: PropTypes.object,
		metaData: PropTypes.object,
	};

	countrieCodes = [];
	paymentGatewayList;
	idCardTypes = [];

	constructor(props) {
		super(props);
		this.state = {
			mobileError: null,
			emailError: null,
			confirmEmailError: null,
			selectedPaymentGateway: null,
			showBookingConfirmModal: false,
			wallet: false,
			walletMoney: 0,
			confirmTabSelected: 1,
			selectSeatsOnward: [],
			selectSeatsReturn: [],
			journeyTypeActive: 1,
		};
		// console.log('this.props payment options', this.props);
	}

	componentWillMount() {
		if (
			this.props.pbServiceList.bookingDetailsOnward &&
			this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook
		) {
			this.setState({
				selectSeatsOnward: this.seatTypesFrequeny(
					this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook,
				),
			});
		}
		if (
			this.props.pbServiceList.bookingDetailsReturn &&
			this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook
		) {
			this.setState({
				selectSeatsReturn: this.seatTypesFrequeny(
					this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook,
				),
			});
		}
	}

	componentDidUpdate() {
		for (let c of this.props.home.metaData.country_codes) {
			this.countrieCodes.push({
				id: c,
				name: '+' + c,
			});
		}
		this.paymentGatewayList = CommonService.copyObject(
			this.props.home.metaData.payment_gate_way_list_v1,
		);
	}

	seatTypesFrequeny(arr) {
		var a = [],
			b = [],
			prev = {};

		arr.sort((a, b) => {
			if (a.fare > b.fare) return 1;
			if (b.fare > a.fare) return -1;

			return 0;
		});

		let arr2 = [];

		arr.map(val => {
			if (!val.is_pet_seat) {
				arr2.push({ is_pet_seat: false, ...val });
			} else {
				arr2.push(val);
			}
		});

		arr2.sort((a, b) => {
			if (a.is_pet_seat > b.is_pet_seat) return 1;
			if (b.is_pet_seat > a.is_pet_seat) return -1;

			return 0;
		});

		for (var i = 0; i < arr2.length; i++) {
			if (prev && arr2[i].type !== prev.type) {
				a.push(arr2[i]);
				b.push(1);
			} else {
				if (arr2[i].is_pet_seat !== prev.is_pet_seat) {
					a.push(arr2[i]);
					b.push(1);
				} else {
					b[b.length - 1]++;
				}
			}

			prev = arr2[i];
		}
		return [a, b];
	}

	renderSummaryDetailsCard = (service, date, source, dest) => {
		const { operator } = this.props;
		return (
			<div className="summary-details">
				<div className="location-details">
					<div className="city-name font11 bold-text " style={{ marginBottom: 5 }}>
						<img
							className="icon-source"
							src={getIcons('Origin', operator)}
							alt={this.props.t('TRANSLATIONS.ICON_SOURCE')}
							style={{ marginRight: 8, width: 18, marginTop: -3 }}
						/>
						<span className="font11">{source || ''}</span>
					</div>
					<div className="address light-text font9">
						{this.props.tariffData &&
							this.props.tariffData.origin &&
							this.props.tariffData.origin.address}
					</div>
				</div>
				<div className="location-details">
					<div className="city-name font11 bold-text " style={{ marginBottom: 5 }}>
						<img
							className="icon-dest"
							src={getIcons('Destination', operator)}
							style={{ marginRight: 8, width: 18 }}
							alt=""
						/>
						<span className="font11">{dest || null}</span>
					</div>
					<div className="address light-text font9 ">
						{this.props.tariffData &&
							this.props.tariffData.destination &&
							this.props.tariffData.destination.address}
					</div>
				</div>
				{service.route ? (
					<div className="duration light-text font10">
						<img className="icon-source" src="/static/images/icons/icon_duration.svg" alt="" />
						<span>{this.props.t('PASSENGER_DETAILS.DURATION')} : </span> &nbsp;
						<span className="time">
							{service.route.duration}&nbsp;
							<span className="hours">{this.props.t('RESULTS_PAGE.HOURS')}</span>
						</span>
					</div>
				) : null}
			</div>
		);
	};

	render() {
		const { t } = this.props;
		let selectedServiceOnward =
			this.props.pbServiceList && this.props.pbServiceList.selectedServiceOnward
				? this.props.pbServiceList.selectedServiceOnward
				: {};
		let onwardPBDate = this.props.home ? this.props.home.onwardPBDate : null;
		let sourceCityOnward = this.props.tariffData.origin ? this.props.tariffData.origin.name : null;
		let destCityOnward = this.props.tariffData.destination
			? this.props.tariffData.destination.name
			: null;

		console.log('LOG___ this.props.metaData', this.props.metaData);

		return (
			<div className="pb-payment-details-payment-right-side-bar journey-summary-sidebar ">
				<div className="kupos-card">
					<div>
						<div className="summary-title font13 bold-text">
							{t('PASSENGER_DETAILS.SUMMARY')}{' '}
							<span className="bold-text"> {t('PASSENGER_DETAILS.SUMMARY_BOLD')}</span>
						</div>
						<div style={styles.underline} />

						{this.renderSummaryDetailsCard(
							selectedServiceOnward,
							onwardPBDate,
							sourceCityOnward,
							destCityOnward,
						)}
					</div>

					<div className="payment-details-sidebar">
						<div className="payment-seats">
							{this.props.tariffData && (
								<div className="payment-seat-row flex-row font10">
									<div>
										<span>{this.props.tariffData.no_of_passengers}x </span>
										{this.props.isRoundTrip ? 'Pasajes ida y vuelta' : 'Pasajes ida'}
									</div>
									<div className="bold-text">
										CLP{' '}
										{
											CommonService.currency(
												this.props.isRoundTrip
													? this.props.tariffData.round_trip_fare *
													this.props.tariffData.no_of_passengers
													: this.props.tariffData.total_fare,
											).split(',')[0]
										}
									</div>
								</div>
							)}
						</div>

						<div className="discount-block fl ">
							<div className="discount-row flex-row">
								<div className="font10">{t('PASSENGER_DETAILS.PROMO_CODE')}</div>
								<div
									className=" font10 bold-text "
									style={{
										minWidth: 80,
										display: 'flex',
										justifyContent: 'flex-end',
										alignItems: 'center',
										color:
											this.props.operator &&
											this.props.operator.color_codes &&
											this.props.operator.color_codes.primary_color &&
											this.props.operator.color_codes.primary_color,
									}}
								>
									- CLP{' '}
									{
										CommonService.currency(
											this.props.promoCouponAmount ? this.props.promoCouponAmount : 0,
										).split(',')[0]
									}
								</div>
							</div>

							{/* <div className="payment-seats">
                {this.props.tariffData && (
                  <div className="payment-seat-row flex-row font10">
                    <div>{'Monto en USD'}</div>
                    <div className="bold-text">
                      USD{' '}
                      {
                        CommonService.currency(
                          this.props.isRoundTrip
                            ? this.props.tariffData.round_trip_fare *
                                this.props.tariffData.no_of_passengers
                            : this.props.tariffData.total_fare,
                        ).split(',')[0]
                      }
                    </div>
                  </div>
                )}
              </div> */}

							{this.props.metaData &&
								this.props.metaData.currency_conversions &&
								sessionStorage.getItem('paymentGatewaySelected') == 23 && (
									<div className="payment-seat-row flex-row font10">
										<div>{'Monto en USD'}</div>
										<div className="bold-text">
											USD ${''}
											{this.props.isRoundTrip
												? this.props.tariffData.round_trip_fare *
												this.props.tariffData.no_of_passengers *
												this.props.metaData.currency_conversions.clp_to_usd
												: this.props.tariffData.total_fare *
												this.props.metaData.currency_conversions.clp_to_usd}
										</div>
									</div>
								)}
						</div>
					</div>
				</div>
				<div
					className="total bold"
					style={
						this.props.operator &&
							this.props.operator.color_codes &&
							this.props.operator.color_codes.primary_color
							? { backgroundColor: this.props.operator.color_codes.primary_color }
							: null
					}
				>
					<div className="total-row flex-row font13 " style={{ paddingTop: 8, paddingBottom: 8 }}>
						<div>TOTAL</div>
						<div>
							CLP{' '}
							{/* {
                CommonService.currency(
                  this.props.isRoundTrip
                    ? this.props.tariffData.round_trip_fare * this.props.tariffData.no_of_passengers
                    : this.props.tariffData.total_fare,
                ).split(',')[0]
              } */}
							{CommonService.currency(this.props.calculateNetFare())}
						</div>
						{/* <div>CLP {CommonService.currency(+this.props.calculateNetFare()).split(',')[0]}</div> */}
					</div>
				</div>
			</div>
		);
	}
}

const styles = {
	underline: {
		backgroundColor: '#ffc934',
		width: 64,
		height: 3,
		marginBottom: 20,
		marginTop: 10,
	},
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		pbServiceList: state.pbServiceList,
		home: state.home,
		pbPaymentDetails: state.pbPaymentDetails,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentRightSideBar);



// WEBPACK FOOTER //
// ./src/features/terminal-booking/PaymentRightSideBar.js